module.exports = __webpack_public_path__ + "img/nzavo-recipe-detail.c32d97bb.jpg";